import React, {useEffect, useState} from 'react';
import {Box} from '@mui/material';
import ArrWidgetWrapper from '../../../common/arr-widget-wrapper/ArrWidgetWrapper';
import ArrFunnelChart, {
  FunnelWidgetData,
} from '../../../common/arr-funnel-chart/ArrFunnelChart';
import {t} from 'i18next';
import {useEndToEnd} from '../../../../hooks/dashboard/useDashboard';
import './EndToWidget.scss';

interface EndToEndWidgetProps {
  onReplaceClick: () => void;
}
const EndToEndWidget: React.FC<EndToEndWidgetProps> = ({onReplaceClick}) => {
  const [data, setData] = useState<FunnelWidgetData>();

  const {
    data: endToEndData,
    isLoading: loading,
    isError: error,
  } = useEndToEnd();

  useEffect(() => {
    setData({
      released: endToEndData?.promoted ?? 0,
      notReviewed: endToEndData?.inComplete ?? 0,
      reviewed: endToEndData?.completed ?? 0,
      responsive: endToEndData?.totalResponsive ?? 0,
      privileged: endToEndData?.totalPrivileged ?? 0,
      totalProduced: endToEndData?.producedDocuments ?? 0,
    });
  }, [endToEndData]);

  return (
    <ArrWidgetWrapper
      title={t('dashboard.endToEndWidget.title')}
      tooltipContent={t('dashboard.endToEndWidget.tooltip')}
      showInfo
      showReplace
      onReplaceClick={onReplaceClick}
      loading={loading}
      error={error}
    >
      <Box className="end-to-end-root">
        {data && (
          <ArrFunnelChart
            widgetData={data}
            className="demo-end-to-end-widget"
            width={470}
          />
        )}
      </Box>
    </ArrWidgetWrapper>
  );
};

export default EndToEndWidget;
